/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Section_Free_LimitsInputs */



/**
* | output |
* | --- |
* | "Free Plan Limits" |
*
* @param {Faq_Section_Free_LimitsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faq_section_free_limits = /** @type {((inputs?: Faq_Section_Free_LimitsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Section_Free_LimitsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Free-Plan-Limits")
	return /** @type {LocalizedString} */ ("Free Plan Limits")
});